import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BlogEffects } from './effects/blog.effects';
import { BlogPageComponent } from './blog-page/blog-page.component';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from './components/index';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '../core/material.module';
import { QuillModule } from 'ngx-quill';
import { TranslateModule } from '@ngx-translate/core';
import { OverviewComponent } from './components/overview/overview.component';
import { SharedModule } from '../shared-module/shared.module';
import * as fromBlog from './reducers';

@NgModule({
  declarations: [BlogPageComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    StoreModule.forFeature('blog', fromBlog.reducers),
    EffectsModule.forFeature([BlogEffects]),
    FlexLayoutModule,
    CustomMaterialModule,
    SharedModule,
    QuillModule,
    TranslateModule,
    RouterModule.forChild([
      {
        path: '',
        component: BlogPageComponent,
        children: [
          {
            path: '',
            redirectTo: 'overview',
            pathMatch: 'full',
          },
          {
            path: 'overview',
            component: OverviewComponent,
            pathMatch: 'full',
          },
        ],
      },
    ]),
  ],
})
export class BlogModule {}
